import classNames from 'classnames';
import styles from './index.module.scss';

interface GarageFooterSectionProps {
  readonly bookingsNumber: number | null;
  readonly yearsInBusinessNumber: number | null;
  readonly translations: {
    readonly bookingsNumberText: string;
    readonly yearsInBusinessText: string;
  };
}

export function GarageFooterSection({
  bookingsNumber,
  yearsInBusinessNumber,
  translations: { bookingsNumberText, yearsInBusinessText },
}: GarageFooterSectionProps): JSX.Element {
  return (
    <div className={classNames(styles.GarageFooterSection)}>
      {bookingsNumber !== null && bookingsNumber > 0 && (
        <div className={styles.BookingsNumberSection}>
          <div>{bookingsNumber}+</div>
          <div>{bookingsNumberText}</div>
        </div>
      )}

      <div className={styles.YearsInBusinessSection}>
        <div>{yearsInBusinessNumber}+</div>
        <div>{yearsInBusinessText}</div>
      </div>
    </div>
  );
}

GarageFooterSection.displayName = 'GarageFooterSection';
